import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import useAuthCheck from "./components/hooks/useAuthCheck";
import AdminPublicRoute from "./components/routes/AdminPublicRoute";
import StudentPrivateRoute from "./components/routes/StudentPrivateRoute";
import StudentsPublicRoute from "./components/routes/StudentsPublicRoute";
import AdminPrivateRoute from "./components/routes/adminPrivatRoute";
import Loading from "./components/ui/Loading";
import PageNotFound from "./pages/PageNotFound";
import AddAssignment from "./pages/admin/AddAssignment";
import AddQuiz from "./pages/admin/AddQuiz";
import AddVideo from "./pages/admin/AddVideo";
import AdminLogin from "./pages/admin/AdminLogin";
import Assignment from "./pages/admin/Assignment";
import AssignmentMark from "./pages/admin/AssignmentMark";
import Dashboard from "./pages/admin/Dashboard";
import EditAssignment from "./pages/admin/EditAssignment";
import EditQuiz from "./pages/admin/EditQuiz";
import EditVideo from "./pages/admin/EditVideo";
import Quizzes from "./pages/admin/Quizzes";
import Videos from "./pages/admin/Videos";
import CoursePlayer from "./pages/student/CoursePlayer";
import LeaderBoard from "./pages/student/LeaderBoard";
import Quiz from "./pages/student/Quiz";
import StudentLogin from "./pages/student/StudentLogin";
import StudentRegistration from "./pages/student/StudentRegistration";
import "./styles/output.css";
function App() {
  const authChecked = useAuthCheck();
  return !authChecked ? (
    <Loading />
  ) : (
    <BrowserRouter>
      <Routes>
        {/* student part start  */}
        <Route
          path="/"
          element={
            <StudentsPublicRoute>
              <StudentLogin />
            </StudentsPublicRoute>
          }
        />
        <Route
          path="/registration"
          element={
            <StudentsPublicRoute>
              <StudentRegistration />
            </StudentsPublicRoute>
          }
        />
        <Route
          path="/quiz/:videoId"
          element={
            <StudentPrivateRoute>
              <Quiz />
            </StudentPrivateRoute>
          }
        />
        <Route
          path="/leaderBoard"
          element={
            <StudentPrivateRoute>
              <LeaderBoard />
            </StudentPrivateRoute>
          }
        />
        <Route
          path="/coursePlayer/:videoId"
          element={
            <StudentPrivateRoute>
              <CoursePlayer />
            </StudentPrivateRoute>
          }
        />
        {/* student part end */}

        {/* admin part start  */}
        <Route
          path="/admin/"
          element={
            <AdminPublicRoute>
              <AdminLogin />
            </AdminPublicRoute>
          }
        />
        <Route
          path="/admin/assignment"
          element={
            <AdminPrivateRoute>
              <Assignment />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/assignmentEdit/:assignmentId"
          element={
            <AdminPrivateRoute>
              <EditAssignment />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/addAssignment"
          element={
            <AdminPrivateRoute>
              <AddAssignment />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/assignmentMark"
          element={
            <AdminPrivateRoute>
              <AssignmentMark />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            <AdminPrivateRoute>
              <Dashboard />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/quizzes"
          element={
            <AdminPrivateRoute>
              <Quizzes />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/editQuiz/:quizId"
          element={
            <AdminPrivateRoute>
              <EditQuiz />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/addQuiz"
          element={
            <AdminPrivateRoute>
              <AddQuiz />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/videos"
          element={
            <AdminPrivateRoute>
              <Videos />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/editVideo/:videoId"
          element={
            <AdminPrivateRoute>
              <EditVideo />
            </AdminPrivateRoute>
          }
        />
        <Route
          path="/admin/addVideo"
          element={
            <AdminPrivateRoute>
              <AddVideo />
            </AdminPrivateRoute>
          }
        />
        {/* admin part end  */}

        {/* 404 page */}
        <Route path="/*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
